export default "__VITE_ASSET__ojdeUkOo__"